import { useMemo, useRef } from "react";
import { graphql, useFragment, useSubscription } from "react-relay";
import { WidgetTable, WidgetTableRef } from "widgets/src/WidgetTable";
import { TableFocus_tableWidget$key } from "./__generated__/TableFocus_tableWidget.graphql";
import { TableFocusScrollSubscription } from "./__generated__/TableFocusScrollSubscription.graphql";

export const TableFocus = (props: {
  widget: TableFocus_tableWidget$key;
  detailId?: string;
}) => {
  const widget = useFragment(
    graphql`
      fragment TableFocus_tableWidget on WidgetTable {
        id
        ...WidgetTable_table
      }
    `,
    props.widget
  );

  const ref = useRef<WidgetTableRef>(null);

  useSubscription<TableFocusScrollSubscription>(
    useMemo(
      () => ({
        subscription: graphql`
          subscription TableFocusScrollSubscription($widgetId: ID!) {
            widgetFocusScrollChanged(widgetId: $widgetId)
          }
        `,
        variables: { widgetId: widget.id },
        onNext: (data) => {
          if (data?.widgetFocusScrollChanged)
            ref.current?.scrollTo(data.widgetFocusScrollChanged);
        },
      }),
      [widget.id]
    )
  );

  return (
    <WidgetTable
      ref={ref}
      widget={widget}
      detailId={props.detailId}
      mode="IDLE"
    />
  );
};
